import { render, staticRenderFns } from "./support.vue?vue&type=template&id=ea55495a"
import script from "./support.vue?vue&type=script&lang=js"
export * from "./support.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ea55495a')) {
      api.createRecord('ea55495a', component.options)
    } else {
      api.reload('ea55495a', component.options)
    }
    module.hot.accept("./support.vue?vue&type=template&id=ea55495a", function () {
      api.rerender('ea55495a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/client/form/support.vue"
export default component.exports